var React = require('react');

function NewContentMenu (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("polygon",{"points":"247.91 12.05 235.78 0 0 0 0 24.1 247.91 24.1 247.91 12.05","fill":"#ba3d70","key":0}),React.createElement("text",{"transform":"translate(80.07 16.02)","fontSize":"11.57","fill":"#fff","fontFamily":"Montserrat-Bold, Montserrat","fontWeight":"700","letterSpacing":"-0.02em","key":1},"NEUE INHALTE"),React.createElement("path",{"d":"M247.91,12.05c-3.14-3.18-8.59-8.57-12.13-12V12.05Z","fill":"#ed8023","key":2})]));
}

NewContentMenu.defaultProps = {"width":"247.91","viewBox":"0 0 247.91 24.1"};

module.exports = NewContentMenu;

NewContentMenu.default = NewContentMenu;
